import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import filterNL from '../helpers/filterNL';
import { MCmsLanguagePicker, MLoader } from '../components/molecules';
import {
	OProductBasicInfo,
	OFeaturedImageUpload,
	OImagePreview,
	OProductInfo,
	OSmartInputSection,
	ODestructiveButtons,
} from '../components/organisme';

import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import store from '../redux/store/store';
import {
	fetchDocuments,
	fetchProjectsAll,
	fetchAtexAll,
	fetchCategoriesAll,
} from '../redux/content/contentActions';
import {
	updateForm,
	addProduct,
	updateProduct,
	initForm,
} from '../redux/cms/cmsActions';

import withAuthGuard from '../helpers/withAuthGuard';
import { NLUuid, PRODUCT_TYPE_UUIDS, routes } from '../constants';

const mapStateToProps = state => ({
	languages: state.head.utilities.languages,
	isValid: state.cms.isFormValid,
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
	form: state.cms.form,

	featuredImage: get(state, 'cms.form.featuredImage.value', {}),
	images: get(state, 'cms.form.images.value', []),
	document: get(state, 'cms.form.document.value', []),
	projects: get(state, 'cms.form.projects.value', []),
	relatedProducts: get(state, 'cms.form.relatedProducts.value', []),
	relatedProductsItems: get(state, 'product.result', []),
	atex: get(state, 'cms.form.atex.value', []),
	productCategoryId: get(state, 'cms.form.productCategoryId.value', ''),
	id: get(state, 'cms.form.id.value', ''),
	type: get(state, 'cms.form.type.value', 0),
	productTypeUuid: get(state, 'cms.form.productTypeUuid.value', ''),
	videoLink: get(state, 'cms.form.videoLink.value', ''),
	featuredOrder: get(state, 'cms.form.featuredOrder.value', 1),
	webshop: get(state, 'cms.form.webshop.value', ''),
	price: get(state, 'cms.form.price.value', ''),

	documentItems: state.content.documents,
	projectItems: state.content.projects.result,
	atexItems: state.content.atex,
	categoryItems: state.content.category,
});

class CreateProductPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			language: undefined,
			isEditMode: false,
		};

		this.bindHandles();
	}
	componentDidMount() {
		const editMode = this.checkForEditMode();

		this.props.setCmsHead({ ...CMS_CONFIG.PRODUCT.header.create });
		this.initForm({ editMode });
	}

	componentWillReceiveProps(props) {
		if (!this.state.language && props.languages.length > 0) {
			this.setState({ language: props.languages[0].uuid });
		}
	}

	initForm({ editMode = false }) {
		const values = {
			type: 0,
			productTypeUuid: PRODUCT_TYPE_UUIDS.HOUSEHOLD,
			featuredOrder: 1,
		};

		if (editMode) {
			const products = store.getState().product.result.filter(item => item.id === this.props.match.params.slug);
			const nlProduct = products.find(prod => prod.languageUuid === NLUuid);

			if (!products || !products.length || products.length === 0) {
				this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.PRODUCTS}`);
				return;
			}

			if (products.length) {
				values.featuredImage = nlProduct.featuredImage;
				values.images = nlProduct.images;
				values.document = nlProduct.documents;
				values.relatedProducts = nlProduct.relatedProduct;
				values.projects = nlProduct.projects;
				values.atex = nlProduct.atexes;
				values.id = nlProduct.id;
				values.productTypeUuid = nlProduct.productTypeUuid;
				values.videoLink = nlProduct.videoLink;
				values.featuredOrder = nlProduct.featuredOrder;
				values.webshop = nlProduct.webshop;
				values.price = nlProduct.price;

				let productTypeSlug = '';
				switch (values.productTypeUuid) {
					case PRODUCT_TYPE_UUIDS.HOUSEHOLD:
						values.type = 0;
						productTypeSlug = 'household';
						break;
					case PRODUCT_TYPE_UUIDS.INDUSTRIAL:
						values.type = 1;
						productTypeSlug = 'industrial';
						break;
					case PRODUCT_TYPE_UUIDS.RENT:
						values.type = 2;
						productTypeSlug = 'rent';
						break;
					default:
				}

				this.props.fetchCategoriesAll(productTypeSlug);
				values.productCategoryId = get(products[0], 'productCategory.id', '');

				products.forEach((product) => {
					values[`${product.languageUuid}-name`] = product.name;
					values[`${product.languageUuid}-slug`] = product.slug;
					values[`${product.languageUuid}-description`] = product.description;
					values[`${product.languageUuid}-uuid`] = product.uuid;
					values[`${product.languageUuid}-seoTitle`] = product.seoTitle;
					values[`${product.languageUuid}-seoDescription`] = product.seoDescription;

					CMS_CONFIG.PRODUCT_INFO.forEach((productInfoItem) => {
						values[`${product.languageUuid}-${productInfoItem.key}`] = product[productInfoItem.key];
					});
				});
			}
		}

		this.props.fetchCategoriesAll();
		this.props.fetchAtexAll();
		this.props.fetchDocuments();
		this.props.fetchProjectsAll();

		this.props.initForm({
			fields: CMS_CONFIG.CREATE.product(this.props.languages),
			values,
		});
	}

	checkForEditMode() {
		const isEditMode = 'slug' in this.props.match.params;
		this.setState({ isEditMode });

		return isEditMode;
	}

	bindHandles() {
		this.handleLanguageSwitch = this.handleLanguageSwitch.bind(this);
		this.handleFieldChange = this.handleFieldChange.bind(this);

		this.handleSave = this.handleSave.bind(this);
		this.handleSmartFieldRemove = this.handleSmartFieldRemove.bind(this);

		this.initForm = this.initForm.bind(this);
		this.handleImageListUpload = this.handleImageListUpload.bind(this);
		this.handleRemoveImage = this.handleRemoveImage.bind(this);
	}

	handleLanguageSwitch(language) {
		this.setState({ language });
	}

	handleLangFieldChange({ field, value, error }) {
		if (this.state.language) {
			this.props.updateForm({ key: `${this.state.language}-${field}`, value, valid: !error });
		}
	}

	handleFieldChange({ field, value, error }) {
		this.props.updateForm({ key: field, value, valid: !error });
	}

	handleSmartFieldChange({ field, value }) {
		this.props.updateForm({ key: field, value: this.props[field].concat([value]), valid: true });
	}

	handleSave() {
		if (!this.props.isValid) {
			return;
		}

		if (this.state.isEditMode) {
			this.props.updateProduct(this.props.history);
		} else {
			this.props.addProduct(this.props.history);
		}
	}

	handleSmartFieldRemove({ field, uuid }) {
		const value = this.props[field].filter(item => item.uuid !== uuid);

		this.props.updateForm({ key: field, value, valid: true });
	}

	handleTypeChange({ value, error }) {
		let productTypeUuid = '';
		let productTypeSlug;
		switch (value) {
			case 0:
				productTypeUuid = PRODUCT_TYPE_UUIDS.HOUSEHOLD;
				productTypeSlug = 'household';
				break;
			case 1:
				productTypeUuid = PRODUCT_TYPE_UUIDS.INDUSTRIAL;
				productTypeSlug = 'industrial';
				break;
			case 2:
				productTypeUuid = PRODUCT_TYPE_UUIDS.RENT;
				productTypeSlug = 'rent';
				break;
			default:
		}
		this.props.fetchCategoriesAll(productTypeSlug);
		this.props.updateForm({ key: 'type', value, valid: !error });
		this.props.updateForm({ key: 'productTypeUuid', value: productTypeUuid, valid: !error });
		this.props.updateForm({ key: 'productCategoryId', value: undefined, valid: false });
	}
	handleImageListUpload(item) {
		this.props.updateForm({ key: 'images', value: this.props.images.concat([item]), valid: true });
	}
	handleRemoveImage(item) {
		this.props.updateForm({ key: 'images', value: this.props.images.filter(image => image.uuid !== item.uuid), valid: true });
	}

	render() {
		let content;

		if (this.state.isUploading) {
			content = <MLoader className="article--loader article--loader-create" />;
		}

		let name = '';
		let slug = '';
		let description = '';
		let seoTitle = '';
		let seoDescription = '';

		if (this.state.language) {
			name = get(this.props, `form['${this.state.language}-name'].value`, '');
			slug = get(this.props, `form['${this.state.language}-slug'].value`, '');
			description = get(this.props, `form['${this.state.language}-description'].value`, '');
			seoTitle = get(this.props, `form['${this.state.language}-seoTitle'].value`, '');
			seoDescription = get(this.props, `form['${this.state.language}-seoDescription'].value`, '');
		}

		return (
			<div className="layout-cms--wrapper">
				<div className="layout-cms--content-body--create">
					<div className="section-cms--language-picker">
						<MCmsLanguagePicker
							items={this.props.languages}
							active={this.state.language}
							onClick={this.handleLanguageSwitch}
						/>
					</div>
					<OProductBasicInfo
						type={this.props.type}
						title={name}
						slug={slug}
						video={this.props.videoLink}
						price={this.props.price}
						order={this.props.featuredOrder}
						webshop={this.props.webshop}
						category={this.props.productCategoryId}
						categoryItems={filterNL(this.props.categoryItems)}
						description={description}
						seoTitle={seoTitle}
						seoDescription={seoDescription}
						onTypeChange={(value, error) => this.handleTypeChange({ field: 'type', value, error })}
						onTitleChange={(value, error) => this.handleLangFieldChange({ field: 'name', value, error })}
						onSlugChange={(value, error) => this.handleLangFieldChange({ field: 'slug', value, error })}
						onVideoChange={(value, error) => this.handleFieldChange({ field: 'videoLink', value, error })}
						onOrderChange={(value, error) => this.handleFieldChange({ field: 'featuredOrder', value, error })}
						onWebshopChange={(value, error) => this.handleFieldChange({ field: 'webshop', value, error })}
						onPriceChange={(value, error) => this.handleFieldChange({ field: 'price', value, error })}
						onCategoryChange={(value, error) => this.handleFieldChange({ field: 'productCategoryId', value, error })}
						onDescriptionChange={(value, error) => this.handleLangFieldChange({ field: 'description', value, error })}
						onSeoTitleChange={(value, error) => this.handleLangFieldChange({ field: 'seoTitle', value, error })}
						onSeoDescriptionChange={(value, error) => this.handleLangFieldChange({ field: 'seoDescription', value, error })}
					/>
					<OFeaturedImageUpload
						id="productFeaturedImage"
						title="feature image"
						imageURL={this.props.featuredImage.url}
						className="o-cms-file-upload--product"
						onUpload={(value, error) => this.handleFieldChange({ field: 'featuredImage', value, error })}
					/>
					<OImagePreview
						onUpload={this.handleImageListUpload}
						items={this.props.images}
						onRemove={this.handleRemoveImage}
					/>
					<OProductInfo
						form={this.props.form}
						languageUuid={this.state.language}
						onChange={({ value, error, field }) => this.handleLangFieldChange({ field, value, error })}
					/>
					<OSmartInputSection
						title="Documenten"
						value={this.props.document}
						items={this.props.documentItems}
						onSelect={value => this.handleSmartFieldChange({ field: 'document', value })}
						onDelete={uuid => this.handleSmartFieldRemove({ field: 'document', uuid })}
						optional
					/>
					<OSmartInputSection
						title="Gerelateerde producten"
						value={this.props.relatedProducts}
						items={filterNL(this.props.relatedProductsItems)}
						onSelect={value => this.handleSmartFieldChange({ field: 'relatedProducts', value })}
						onDelete={uuid => this.handleSmartFieldRemove({ field: 'relatedProducts', uuid })}
						optional
					/>
					<OSmartInputSection
						title="Projecten"
						value={this.props.projects}
						items={filterNL(this.props.projectItems)}
						onSelect={value => this.handleSmartFieldChange({ field: 'projects', value })}
						onDelete={uuid => this.handleSmartFieldRemove({ field: 'projects', uuid })}
						optional
					/>
					<OSmartInputSection
						title="Atex tags"
						value={this.props.atex}
						items={filterNL(this.props.atexItems)}
						onSelect={value => this.handleSmartFieldChange({ field: 'atex', value })}
						onDelete={uuid => this.handleSmartFieldRemove({ field: 'atex', uuid })}
						optional
					/>
				</div>
				<div className="section-cms--destructive-buttons">
					<ODestructiveButtons
						onSave={this.handleSave}
						saveEnabled={this.props.isValid}
					/>
				</div>
				{content}
			</div>
		);
	}
}

CreateProductPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	updateForm: PropTypes.func.isRequired,
	initForm: PropTypes.func.isRequired,
	addProduct: PropTypes.func.isRequired,
	updateProduct: PropTypes.func.isRequired,
	fetchDocuments: PropTypes.func.isRequired,
	fetchProjectsAll: PropTypes.func.isRequired,
	fetchAtexAll: PropTypes.func.isRequired,
	fetchCategoriesAll: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	updateForm,
	addProduct,
	updateProduct,
	initForm,
	fetchDocuments,
	fetchProjectsAll,
	fetchAtexAll,
	fetchCategoriesAll,
})(CreateProductPage)));



// WEBPACK FOOTER //
// ./src/CMS/create-product.js